import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import React, { useEffect, useState, useCallback, useRef, cloneElement } from 'react';
import ReactDOM from 'react-dom';
import { tuple } from '../_utils/type';
import debounce from 'lodash/debounce';
import classNames from 'classnames';
import devWarning from '../_utils/devwarning';
import { useResizeObserver } from './hooks';
export var Placements = tuple('top', 'left', 'right', 'bottom', 'topLeft', 'topRight', 'bottomLeft', 'bottomRight', 'leftTop', 'leftBottom', 'rightTop', 'rightBottom');
export var Triggers = tuple('hover', 'focus', 'click', 'contextMenu');

function getTranslate(node, param) {
  var _a;

  var translates = ((_a = document.defaultView) === null || _a === void 0 ? void 0 : _a.getComputedStyle(node, null).transform.substring(7)) || '';
  var result = translates.match(/\(([^)]*)\)/);
  var matrix = result ? result[1].split(',') : translates.split(',');

  if (param === 'x' || param === undefined) {
    return matrix.length > 6 ? parseFloat(matrix[12]) : parseFloat(matrix[4]);
  } else if (param === 'y') {
    return matrix.length > 6 ? parseFloat(matrix[13]) : parseFloat(matrix[5]);
  } else if (param === 'z') {
    return matrix.length > 6 ? parseFloat(matrix[14]) : 0;
  } else if (param === 'rotate') {
    return matrix.length > 6 ? getRotate([parseFloat(matrix[0]), parseFloat(matrix[1]), parseFloat(matrix[4]), parseFloat(matrix[5])]) : getRotate(_mapInstanceProperty(matrix).call(matrix, function (i) {
      return parseFloat(i);
    }));
  }
}

function getRotate(matrix) {
  var aa = Math.round(180 * Math.asin(matrix[0]) / Math.PI);
  var bb = Math.round(180 * Math.acos(matrix[1]) / Math.PI);
  var cc = Math.round(180 * Math.asin(matrix[2]) / Math.PI);
  var dd = Math.round(180 * Math.acos(matrix[3]) / Math.PI);
  var deg = 0;

  if (aa === bb || -aa === bb) {
    deg = dd;
  } else if (-aa + bb === 180) {
    deg = 180 + cc;
  } else if (aa + bb === 180) {
    deg = 360 - cc || 360 - dd;
  }

  return deg >= 360 ? 0 : deg;
}

var getTranslatePos = function getTranslatePos(el) {
  var elPos = {
    top: getTranslate(el, 'y') || 0,
    left: getTranslate(el, 'x') || 0
  };

  if (el.parentElement) {
    var parentPos = getTranslatePos(el.parentElement);
    elPos.top += parentPos.top;
    elPos.left += parentPos.left;
  }

  return elPos;
};

var getOffsetPos = function getOffsetPos(el) {
  var elPos = {
    top: el.offsetTop,
    left: el.offsetLeft
  };

  if (el.offsetParent) {
    var parentPos = getOffsetPos(el.offsetParent);
    elPos.top += parentPos.top;
    elPos.left += parentPos.left;
  }

  return elPos;
};

var getBorderWidth = function getBorderWidth(el) {
  var border = {
    top: 0,
    left: 0
  };

  if (el.offsetParent) {
    var _context, _context2;

    var parentBorder = getBorderWidth(el.offsetParent);
    border.top += parentBorder.top + parseInt(_sliceInstanceProperty(_context = getComputedStyle(el.offsetParent, null).borderTopWidth).call(_context, 0, -2));
    border.left += parentBorder.left + parseInt(_sliceInstanceProperty(_context2 = getComputedStyle(el.offsetParent, null).borderTopWidth).call(_context2, 0, -2));
  }

  return border;
};

var getScrollDist = function getScrollDist(el, container) {
  var elScroll = {
    top: el.scrollTop,
    left: el.scrollLeft
  };
  var isFixed = getComputedStyle(el, null).getPropertyValue('position') === 'fixed';

  if (isFixed) {
    elScroll.top -= document.documentElement.scrollTop;
    elScroll.left -= document.documentElement.scrollLeft;
  } else if (el.parentElement && container.contains(el.parentElement)) {
    var parentScroll = getScrollDist(el.parentElement, container);
    elScroll.top += parentScroll.top;
    elScroll.left += parentScroll.left;
  }

  return elScroll;
};

function usePopper(locatorElement, popperElement, props) {
  var _context3, _context4, _arrowStyle;

  var prefixCls = props.prefixCls,
      onTrigger = props.onTrigger,
      popperStyle = props.popperStyle,
      _props$arrow = props.arrow,
      arrow = _props$arrow === void 0 ? false : _props$arrow,
      onVisibleChange = props.onVisibleChange,
      popperClassName = props.popperClassName,
      _props$arrowOffset = props.arrowOffset,
      arrowOffset = _props$arrowOffset === void 0 ? 12 : _props$arrowOffset,
      _props$arrowSize = props.arrowSize,
      arrowSize = _props$arrowSize === void 0 ? 4.25 : _props$arrowSize,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? 'click' : _props$trigger,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'top' : _props$placement,
      _props$gap = props.gap,
      defaultGap = _props$gap === void 0 ? 4 : _props$gap,
      _props$scrollHidden = props.scrollHidden,
      scrollHidden = _props$scrollHidden === void 0 ? false : _props$scrollHidden,
      _props$mouseEnterDela = props.mouseEnterDelay,
      mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0.1 : _props$mouseEnterDela,
      _props$mouseLeaveDela = props.mouseLeaveDelay,
      mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela,
      _props$defaultVisible = props.defaultVisible,
      defaultVisible = _props$defaultVisible === void 0 ? false : _props$defaultVisible,
      _props$autoPlacement = props.autoPlacement,
      autoPlacement = _props$autoPlacement === void 0 ? true : _props$autoPlacement,
      _props$clickToClose = props.clickToClose,
      clickToClose = _props$clickToClose === void 0 ? true : _props$clickToClose,
      _props$getTriggerElem = props.getTriggerElement,
      getTriggerElement = _props$getTriggerElem === void 0 ? function (locatorNode) {
    return locatorNode;
  } : _props$getTriggerElem,
      _props$getPopupContai = props.getPopupContainer,
      getPopupContainer = _props$getPopupContai === void 0 ? function () {
    return document.body;
  } : _props$getPopupContai;
  var arrowWidth = Math.sqrt(2 * Math.pow(arrowSize, 2));
  var componentName = (prefixCls === null || prefixCls === void 0 ? void 0 : prefixCls.split('-')[1]) || '';
  devWarning(Placements.indexOf(placement) === -1, componentName, _concatInstanceProperty(_context3 = "cannot found ".concat(componentName, " placement '")).call(_context3, placement, "'"));
  var isWrongTrigger = Array.isArray(trigger) ? trigger.some(function (v) {
    return !_includesInstanceProperty(Triggers).call(Triggers, v);
  }) : Triggers.indexOf(trigger) === -1;
  devWarning(isWrongTrigger, componentName, _concatInstanceProperty(_context4 = "cannot found ".concat(componentName, " trigger '")).call(_context4, trigger, "'"));
  var locatorEl = useRef();
  var popperEl = useRef();
  var locatorRef = locatorElement.ref || locatorEl;
  var popperRef = popperElement.ref || popperEl;
  var container = getPopupContainer(locatorRef.current || document.body);

  _Promise.resolve().then(function () {
    var triggerNode = getTriggerElement(locatorRef.current);
    var container = getPopupContainer(locatorRef.current);
    devWarning(!triggerNode, componentName, "getTriggerElement() must return a HTMLElement, but now it does not return anything");
    devWarning(!container, componentName, "getPopupContainer() must return a HTMLElement, but now it does not return anything");
  });

  var initPos = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: 0,
    width: 0
  };
  var initAlign = {
    top: 0,
    left: 0
  };
  var gap = defaultGap + (arrow ? 10 : 0);

  var _useState = useState(initPos),
      _useState2 = _slicedToArray(_useState, 2),
      mousePos = _useState2[0],
      setMousePos = _useState2[1];

  var _useState3 = useState(initAlign),
      _useState4 = _slicedToArray(_useState3, 2),
      arrowPos = _useState4[0],
      setArrowPos = _useState4[1];

  var _useState5 = useState(!!props.visible || defaultVisible),
      _useState6 = _slicedToArray(_useState5, 2),
      exist = _useState6[0],
      setExist = _useState6[1];

  var _useState7 = useState(!!props.visible || defaultVisible),
      _useState8 = _slicedToArray(_useState7, 2),
      canAlign = _useState8[0],
      setCanAlign = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      visible = _useState10[0],
      setVisible = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      active = _useState12[0],
      setActive = _useState12[1];

  useEffect(function () {
    if (props.visible) {
      !exist && setExist(true);
      setCanAlign(true);
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [exist, props.visible]);

  var _useState13 = useState(''),
      _useState14 = _slicedToArray(_useState13, 2),
      evType = _useState14[0],
      setEvType = _useState14[1];

  var _useState15 = useState(),
      _useState16 = _slicedToArray(_useState15, 2),
      align = _useState16[0],
      setAlign = _useState16[1];

  var _useState17 = useState(placement),
      _useState18 = _slicedToArray(_useState17, 2),
      nextPlacement = _useState18[0],
      setNextPlacement = _useState18[1];

  var alignPopper = useCallback(function () {
    if ((locatorRef === null || locatorRef === void 0 ? void 0 : locatorRef.current) && (popperRef === null || popperRef === void 0 ? void 0 : popperRef.current)) {
      var _popperRef$current$ge = popperRef.current.getBoundingClientRect(),
          popperWidth = _popperRef$current$ge.width,
          popperHeight = _popperRef$current$ge.height;

      var _locatorRef$current$g = locatorRef.current.getBoundingClientRect(),
          top = _locatorRef$current$g.top,
          bottom = _locatorRef$current$g.bottom,
          left = _locatorRef$current$g.left,
          right = _locatorRef$current$g.right,
          height = _locatorRef$current$g.height,
          width = _locatorRef$current$g.width;

      var _getOffsetPos = getOffsetPos(container),
          containerTop = _getOffsetPos.top,
          containerLeft = _getOffsetPos.left;

      var _getOffsetPos2 = getOffsetPos(locatorRef.current),
          locatorTop = _getOffsetPos2.top,
          locatorLeft = _getOffsetPos2.left;

      var _getTranslatePos = getTranslatePos(locatorRef.current),
          translateTop = _getTranslatePos.top,
          translateLeft = _getTranslatePos.left;

      var _getBorderWidth = getBorderWidth(locatorRef.current),
          borderTop = _getBorderWidth.top,
          borderLeft = _getBorderWidth.left;

      var _getScrollDist = getScrollDist(locatorRef.current.parentElement, container),
          scrollTop = _getScrollDist.top,
          scrollLeft = _getScrollDist.left;

      var locatorPos = {
        width: width,
        height: height,
        top: locatorTop + borderTop + translateTop - containerTop - scrollTop,
        left: locatorLeft + borderLeft + translateLeft - containerLeft - scrollLeft,
        right: locatorLeft + borderLeft + translateLeft + width - containerLeft - scrollLeft,
        bottom: locatorTop + borderTop + translateTop + height - containerTop - scrollTop
      };
      var currentPos = trigger === 'contextMenu' ? mousePos : locatorPos;
      var currentPlacement = nextPlacement;

      if (autoPlacement) {
        var _context5;

        if (top - gap - popperHeight <= 5 && bottom + gap + popperHeight < document.body.clientHeight - 5) {
          currentPlacement = currentPlacement.replace('top', 'bottom');
        }

        if (bottom + gap + popperHeight >= document.body.clientHeight - 5 && top - gap - popperHeight > 5) {
          currentPlacement = currentPlacement.replace('bottom', 'top');
        }

        if (left + popperWidth >= document.body.clientWidth - 5 && right - popperWidth > 5) {
          currentPlacement = currentPlacement.replace('Left', 'Right');
        }

        if (right - popperWidth <= 5 && left + popperWidth < document.body.clientWidth - 5) {
          currentPlacement = currentPlacement.replace('Right', 'Left');
        }

        if (top + popperHeight >= document.body.clientHeight - 5 && bottom - popperHeight > 5) {
          currentPlacement = currentPlacement.replace('Top', 'Bottom');
        }

        if (bottom - popperHeight <= 5 && top + popperHeight < document.body.clientHeight - 5) {
          currentPlacement = currentPlacement.replace('Bottom', 'Top');
        }

        if (left - gap - popperWidth <= 5 && right + gap + popperWidth < document.body.clientWidth - 5) {
          currentPlacement = currentPlacement.replace('left', 'right');
        }

        if (right + gap + popperWidth >= document.body.clientWidth - 5 && left - gap - popperWidth > 5) {
          currentPlacement = currentPlacement.replace('right', 'left');
        }

        if (_includesInstanceProperty(_context5 = ['top', 'bottom']).call(_context5, currentPlacement)) {
          if (right - width / 2 + popperWidth / 2 >= document.body.clientWidth - 5 && right - popperWidth > 5) {
            currentPlacement += 'Right';
          }

          if (left - width / 2 - popperWidth / 2 <= 5 && left + popperWidth < document.body.clientWidth - 5) {
            currentPlacement += 'Left';
          }
        }
      }

      var leftLeft = currentPos.left - popperWidth - gap;
      var topTop = currentPos.top - gap - popperHeight;
      var bottomTop = currentPos.top + currentPos.height + gap;
      var rightLeft = currentPos.left + currentPos.width - popperWidth;
      var centerLeft = currentPos.left + (currentPos.width - popperWidth) / 2;
      var centerTop = currentPos.top - (popperHeight - currentPos.height) / 2;
      var topBottom = currentPos.bottom - popperHeight;
      var leftRight = currentPos.right + gap;
      var mapAlign = {
        topLeft: {
          left: currentPos.left,
          top: topTop
        },
        top: {
          left: centerLeft,
          top: topTop
        },
        topRight: {
          left: rightLeft,
          top: topTop
        },
        bottomLeft: {
          left: currentPos.left,
          top: bottomTop
        },
        bottom: {
          left: centerLeft,
          top: bottomTop
        },
        bottomRight: {
          left: rightLeft,
          top: bottomTop
        },
        leftTop: {
          left: leftLeft,
          top: currentPos.top
        },
        left: {
          left: leftLeft,
          top: centerTop
        },
        leftBottom: {
          left: leftLeft,
          top: topBottom
        },
        rightTop: {
          left: leftRight,
          top: currentPos.top
        },
        right: {
          left: leftRight,
          top: centerTop
        },
        rightBottom: {
          left: leftRight,
          top: topBottom
        }
      };
      var alignPos = mapAlign[currentPlacement];
      var _arrowPos = {
        top: 0,
        left: 0
      };

      if (/left/.test(currentPlacement) || /right/.test(currentPlacement)) {
        if (/Top/.test(currentPlacement)) {
          _arrowPos.top = arrowOffset;
        } else if (/Bottom/.test(currentPlacement)) {
          _arrowPos.top = popperHeight - arrowOffset - 2 * arrowSize;
        } else {
          _arrowPos.top = (popperHeight - arrowWidth) / 2 - 1;
        }

        if (top <= 0) {
          alignPos.top = locatorPos.top;
          _arrowPos.top = arrowOffset;
        } else if (bottom - height / 4 >= document.body.clientHeight) {
          alignPos.top = locatorPos.bottom - popperHeight;
          _arrowPos.top = popperHeight - arrowOffset - 2 * arrowSize;
        } else {
          var _scrollTop = alignPos.top - window.pageYOffset;

          var scrollBottom = alignPos.top + popperHeight - 5 - window.pageYOffset;

          if (_scrollTop < 0) {
            alignPos.top -= _scrollTop;
            _arrowPos.top += _scrollTop;
          }

          if (scrollBottom > document.body.clientHeight) {
            alignPos.top += document.body.clientHeight - scrollBottom;
            _arrowPos.top += scrollBottom - document.body.clientHeight;
          }
        }
      } else if (/top/.test(currentPlacement) || /bottom/.test(currentPlacement)) {
        if (/Left/.test(currentPlacement)) {
          _arrowPos.left = arrowOffset;
        } else if (/Right/.test(currentPlacement)) {
          _arrowPos.left = popperWidth - arrowOffset - 2 * arrowSize;
        } else {
          _arrowPos.left = (popperWidth - arrowWidth) / 2 - 1;
        }

        if (left <= 0) {
          alignPos.left = locatorPos.left;
          _arrowPos.left = arrowOffset;
        } else if (right >= document.body.clientWidth) {
          delete alignPos.left;
          alignPos.right = -1 * (right - document.body.clientWidth);
          _arrowPos.left = popperWidth - arrowOffset - 2 * arrowSize;
        }
      }

      setAlign(alignPos);
      setArrowPos(_arrowPos);
      setNextPlacement(currentPlacement);
    }
  }, [locatorRef, popperRef, container, trigger, mousePos, autoPlacement, gap, arrowOffset, arrowSize, arrowWidth]);
  useEffect(function () {
    if (canAlign) {
      alignPopper();
      setCanAlign(false);
      props.visible === undefined && setVisible(true);
      onVisibleChange && onVisibleChange(true);
      setActive(true);
      setTimeout(function () {
        return setActive(false);
      }, 200);
    }
  }, [alignPopper, canAlign, onVisibleChange, props]);
  var arrowStyle = (_arrowStyle = {}, _defineProperty(_arrowStyle, "--arrowSize", arrowSize + 'px'), _defineProperty(_arrowStyle, "--arrowSpill", arrowWidth / -2 + 'px'), _arrowStyle);
  if (arrowPos.top) arrowStyle["--arrowTop"] = arrowPos.top + 'px';
  if (arrowPos.left) arrowStyle["--arrowLeft"] = arrowPos.left + 'px';

  var popperContainerStyle = _extends(_extends(_extends({
    position: 'absolute'
  }, align), arrow ? arrowStyle : {}), popperStyle);

  var popperProps = {
    ref: popperRef,
    style: popperContainerStyle,
    className: classNames(prefixCls, popperClassName, nextPlacement, _defineProperty({
      arrow: arrow,
      hidden: !visible
    }, "".concat(nextPlacement, "-active"), active))
  };
  var popperNode = popperRef.current;
  var locatorNode = locatorRef.current;
  useResizeObserver(popperNode || document.body, alignPopper);
  useResizeObserver(locatorNode || document.body, alignPopper);
  var showPopper = useCallback(function (evType) {
    if (!disabled) {
      !exist && setExist(true);
      setEvType(evType);

      if (onTrigger) {
        var mapTrigger = {
          mouseenter: 'hover',
          mouseup: 'click',
          focus: 'focus',
          contextmenu: 'contextMenu'
        };
        onTrigger(mapTrigger[evType]);
      }

      if (!visible || evType === 'contextmenu') {
        setCanAlign(true);
      }
    }
  }, [disabled, exist, onTrigger, visible]);
  var hidePopper = useCallback(function () {
    props.visible === undefined && setVisible(false);
    onVisibleChange && onVisibleChange(false);
  }, [onVisibleChange, props.visible]);

  var matchTrigger = function matchTrigger(words) {
    return Array.isArray(trigger) ? _includesInstanceProperty(trigger).call(trigger, words) : trigger === words;
  };

  useEffect(function () {
    if (exist && visible) {
      var mouseleaveTimer;

      var handleHidePopper = function handleHidePopper(e) {
        var triggerNode = getTriggerElement(locatorRef.current);
        var triggerRect = triggerNode.getBoundingClientRect();
        var popperRect = popperRef.current.getBoundingClientRect();
        var left = /left/.test(nextPlacement) ? popperRect.right : triggerRect.left;
        var right = /right/.test(nextPlacement) ? popperRect.left : triggerRect.right;
        var top = /top/.test(nextPlacement) ? popperRect.bottom : triggerRect.top;
        var bottom = /bottom/.test(nextPlacement) ? popperRect.top : triggerRect.bottom;
        var X = e.clientX,
            Y = e.clientY;
        var inTriggerRect = X > left - 2 && X < right + 2 && Y > top - 2 && Y < bottom + 2;
        var inPopperRect = X > popperRect.left && X < popperRect.right && Y > popperRect.top && Y < popperRect.bottom;
        var ableArea = matchTrigger('contextMenu') ? inPopperRect : inTriggerRect || inPopperRect;

        if (ableArea) {
          mouseleaveTimer && clearTimeout(mouseleaveTimer);
          matchTrigger('focus') && triggerNode.focus();
        } else {
          matchTrigger('hover') ? mouseleaveTimer = window.setTimeout(hidePopper, mouseLeaveDelay * 1000) : hidePopper();
        }
      };

      var debounceHidePopper = debounce(handleHidePopper, 10, {
        leading: true
      });
      var mapEvent = {
        hover: 'mousemove',
        click: 'mousedown',
        focus: 'mousedown',
        contextMenu: 'mousedown'
      };
      popperNode === null || popperNode === void 0 ? void 0 : popperNode.addEventListener('mouseleave', debounceHidePopper);
      Array.isArray(trigger) ? trigger.forEach(function (action) {
        return document.addEventListener(mapEvent[action], debounceHidePopper);
      }) : document.addEventListener(mapEvent[trigger], debounceHidePopper);
      return function () {
        popperNode === null || popperNode === void 0 ? void 0 : popperNode.removeEventListener('mouseleave', debounceHidePopper);
        Array.isArray(trigger) ? trigger.forEach(function (action) {
          return document.removeEventListener(mapEvent[action], debounceHidePopper);
        }) : document.removeEventListener(mapEvent[trigger], debounceHidePopper);
      };
    }
  }, [nextPlacement, evType, exist, getTriggerElement, hidePopper, locatorRef, mouseLeaveDelay, popperRef, visible]);
  useEffect(function () {
    if (visible) {
      var scrollAlign = debounce(function (e) {
        var isPopperScroll = e.target === popperRef.current || popperRef.current.contains(e.target);

        if (scrollHidden && !isPopperScroll) {
          props.visible === undefined && setVisible(false);
          onVisibleChange && onVisibleChange(false);
        }

        alignPopper();
      }, 10);
      window.addEventListener('resize', alignPopper);
      document.addEventListener('scroll', scrollAlign, true);
      locatorNode === null || locatorNode === void 0 ? void 0 : locatorNode.addEventListener('DOMSubtreeModified', alignPopper);
      exist && (popperNode === null || popperNode === void 0 ? void 0 : popperNode.addEventListener('DOMSubtreeModified', alignPopper));
      return function () {
        window.removeEventListener('resize', alignPopper);
        document.removeEventListener('scroll', scrollAlign, true);
        locatorNode === null || locatorNode === void 0 ? void 0 : locatorNode.removeEventListener('DOMSubtreeModified', alignPopper);
        exist && (popperNode === null || popperNode === void 0 ? void 0 : popperNode.removeEventListener('DOMSubtreeModified', alignPopper));
      };
    }
  }, [alignPopper, exist, onVisibleChange, popperNode, props.visible, scrollHidden, locatorNode, visible, popperRef]);
  React.useEffect(function () {
    var triggerNode = getTriggerElement(locatorRef.current);

    if (triggerNode) {
      var mouseenterTimer;

      var clearMouseLeave = function clearMouseLeave() {
        return clearTimeout(mouseenterTimer);
      };

      var addAction = function addAction(action) {
        if (action === 'hover') {
          triggerNode.addEventListener('mouseenter', debounceShowPopper);
          triggerNode.addEventListener('mouseleave', clearMouseLeave);
        } else {
          triggerNode.addEventListener(action, debounceShowPopper);
        }
      };

      var removeAction = function removeAction(action) {
        if (action === 'hover') {
          triggerNode.removeEventListener('mouseenter', debounceShowPopper);
          triggerNode.removeEventListener('mouseleave', clearMouseLeave);
        } else {
          triggerNode.removeEventListener(action, debounceShowPopper);
        }
      };

      var handleShowPopper = function handleShowPopper(e) {
        e.preventDefault();

        if (e.type === 'contextmenu') {
          var currentMousePos = _extends(_extends({}, mousePos), {
            left: e.pageX,
            top: e.pageY,
            right: e.pageX,
            bottom: e.pageY
          });

          setMousePos(currentMousePos);
        }

        if (e.type === 'mouseenter') {
          mouseenterTimer = window.setTimeout(function () {
            return showPopper(e.type);
          }, mouseEnterDelay * 1000);
        } else if (e.type === 'mouseup' && visible) {
          clickToClose && hidePopper();
        } else {
          showPopper(e.type);
        }
      };

      var debounceShowPopper = debounce(handleShowPopper, 10, {
        leading: true
      });
      var mapEvent = {
        hover: 'hover',
        click: 'mouseup',
        focus: 'focus',
        contextMenu: 'contextmenu'
      };
      Array.isArray(trigger) ? trigger.forEach(function (action) {
        return addAction(mapEvent[action]);
      }) : addAction(mapEvent[trigger]);
      return function () {
        Array.isArray(trigger) ? trigger.forEach(function (action) {
          return removeAction(mapEvent[action]);
        }) : removeAction(mapEvent[trigger]);
      };
    }
  }, [getTriggerElement, hidePopper, locatorRef, mouseEnterDelay, mousePos, showPopper, trigger, visible]);
  var Locator = /*#__PURE__*/cloneElement(locatorElement, {
    ref: locatorRef
  });
  var Popper = /*#__PURE__*/React.createElement("div", _extends({}, popperProps), popperElement);
  return /*#__PURE__*/React.createElement(React.Fragment, null, Locator, exist && container && /*#__PURE__*/ReactDOM.createPortal(Popper, container));
}

export default usePopper;